import React from 'react';
import { DateRangePicker as RSuiteDateRangePicker} from 'rsuite';
import dayjs from 'dayjs';
import './DateRangePicker.css';

const DateRangePicker = ({ startDate, endDate, onDateChange }) => {
     const { afterToday } = RSuiteDateRangePicker;
    // Convert dayjs/strings to native Date objects for rsuite
    let start = startDate ? dayjs(startDate).toDate() : null;
    let end = endDate ? dayjs(endDate).toDate() : null;

    // Validate dates
    if (start && isNaN(start.getTime())) start = null;
    if (end && isNaN(end.getTime())) end = null;

    // Prevent red border (invalid range) by ensuring end >= start
    if (start && end && start > end) {
        end = start;
    }

    const value = start && end ? [start, end] : null;

    const handleChange = (range) => {
        if (range) {
            // Convert back to dayjs objects as expected by the parent handlers
            // The parent expects a dayjs object similar to what MUI DatePicker returns
            onDateChange([dayjs(range[0]), dayjs(range[1])]);
        }
    };

    return (
            <RSuiteDateRangePicker
                value={value}
                onChange={handleChange}
                format="yyyy-MM-dd"
                character=" – "
                cleanable={false}
                block
                className="transparent-date-picker"
                style={{ width: '100%', backgroundColor: 'transparent' }}
                placeholder="Select Date Range"
                appearance="subtle"
                shouldDisableDate={afterToday()} // Disable future dates
            />
    );
};

export default DateRangePicker;
